import { styled, GetProps, YStack } from 'tamagui'

export const Container = styled(YStack, {
  name: 'Container',
  
  // Base styles
  marginHorizontal: 'auto',
  width: '100%',
  paddingHorizontal: '$4',
  
  variants: {
    size: {
      sm: { maxWidth: 640 },
      md: { maxWidth: 768 },
      lg: { maxWidth: 1024 },
      xl: { maxWidth: 1280 },
      full: { maxWidth: '100%' },
    },
    align: {
      center: {
        alignItems: 'center',
      },
      start: {
        alignItems: 'flex-start',
      },
      stretch: {
        alignItems: 'stretch',
      },
    },
  } as const,
  
  defaultVariants: {
    size: 'lg',
  },
})

export type ContainerProps = GetProps<typeof Container>
